import React,{useEffect} from 'react'
import Layout from '../Layout'
//import FormAddErga from '../../components/erga_components/FormAddErga'
import { useDispatch,useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getMe } from '../../features/authSlice'
import FormAddErgaCat from '../../components/erga_cat_components/FormAddErgaCat'

const AddErgaCat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {isError} = useSelector((state=>state.auth));

  useEffect(()=>{
      dispatch(getMe());
  },[dispatch]);

  useEffect(()=>{
      if(isError){
          navigate("/");
      }
  },[isError,navigate]);
  return (
    <Layout>
        <FormAddErgaCat/>
    </Layout>
  )
}

export default AddErgaCat